import React from 'react'
import { Link } from 'react-router-dom'
import './Home.css'

const IconAndroid = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M6.32 10.5a.86.86 0 0 0-.86.86v3.78a.86.86 0 1 0 1.71 0v-3.78a.86.86 0 0 0-.85-.86zm11.36 0a.86.86 0 0 0-.86.86v3.78a.86.86 0 1 0 1.71 0v-3.78a.86.86 0 0 0-.85-.86zM7.93 10.07h8.14v6.43c0 .47-.38.86-.86.86h-1.07v2.36a.86.86 0 1 1-1.71 0v-2.36h-1.86v2.36a.86.86 0 1 1-1.71 0v-2.36H8.79a.86.86 0 0 1-.86-.86v-6.43zm.57-.86a4.07 4.07 0 0 1 1.4-2.8L8.84 5.13a.36.36 0 0 1 .51-.51l1.13 1.13a4.5 4.5 0 0 1 3.04 0l1.13-1.13a.36.36 0 0 1 .51.51l-1.06 1.27a4.07 4.07 0 0 1 1.4 2.81H8.5zm2.07-1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2.86 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z" />
  </svg>
)

const IconTelegram = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M21.94 4.39 18.74 19.5c-.24 1.06-.87 1.32-1.76.82l-4.86-3.58-2.34 2.25c-.26.26-.48.48-.98.48l.35-4.94 9-8.12c.39-.35-.09-.55-.6-.2L6.4 13.05l-4.79-1.5c-1.04-.32-1.06-1.04.22-1.54l18.74-7.21c.86-.32 1.62.2 1.37 1.59z" />
  </svg>
)

const IconFacebook = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12z" />
  </svg>
)

function LazyVideo({ src, poster, ariaLabel, priority }) {
  const [mounted, setMounted] = React.useState(false)
  const imgRef = React.useRef(null)

  React.useEffect(() => {
    if (mounted) return undefined
    if (priority) {
      const ric = window.requestIdleCallback
      const id = ric
        ? ric(() => setMounted(true), { timeout: 1500 })
        : window.setTimeout(() => setMounted(true), 300)
      return () => {
        if (ric && window.cancelIdleCallback) window.cancelIdleCallback(id)
        else window.clearTimeout(id)
      }
    }
    const node = imgRef.current
    if (!node || !('IntersectionObserver' in window)) {
      setMounted(true)
      return undefined
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setMounted(true)
          io.disconnect()
        }
      },
      { rootMargin: '300px' }
    )
    io.observe(node)
    return () => io.disconnect()
  }, [priority, mounted])

  const style = { width: '100%', height: 'auto' }
  const posterWebp = poster.replace(/\.jpg$/, '.webp')
  if (!mounted) {
    return (
      <picture>
        <source srcSet={posterWebp} type="image/webp" />
        <img
          ref={imgRef}
          src={poster}
          alt={ariaLabel}
          width="412"
          height="232"
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          style={style}
        />
      </picture>
    )
  }
  return (
    <video
      src={src}
      poster={poster}
      autoPlay
      loop
      muted
      playsInline
      preload="none"
      width="412"
      height="232"
      style={style}
      aria-label={ariaLabel}
    />
  )
}

class Home extends React.Component {
  render() {
    var id = ''
    let linkMB = 'assets/files/XOSOPRO_6886_1806.apk'
    let link3M = 'assets/3M136/DL001_160.apk'
    let videoMB = '/mienbac'
    let video3M = '/ba-mien'
    if (this.props.id) {
      id = this.props.id.toLowerCase()
      videoMB = videoMB + '/' + id
      video3M = video3M + '/' + id
    }
    switch (id) {
      case '0989243804':
        linkMB = 'assets/files/BIGWIN_0989243804_1806.apk'
        break
      case '0702324352': //mb and 3m003
        linkMB = 'assets/files/LOTOVIP_0702324352_1806.apk'
        link3M = 'assets/3M136/DL003_160.apk'
        break
      case '999999':
        linkMB = 'assets/files/TINTUC24H_999999_1806.apk'
        // link3M = 'assets//3M136/DL001.apk'
        break
      // case '0962691695':
      //   linkMB = 'assets/files/XSTD_20252025_1806.apk'
      //   // link3M = 'assets//3M136/DL001.apk'
      //   break
      // case '0395389322':
      //   linkMB = 'assets/files/BAOMOI_0395389322_1806.apk'
      //   // link3M = 'assets//3M136/DL001.apk'
        // break
      case '8679':
        linkMB = 'assets/files/BAOMOI_8679_1806.apk'
        // link3M = 'assets//3M136/DL001.apk'
        break
      case '666888':
        linkMB = 'assets/files/TINTUC24H_666888_1806.apk'
        // link3M = 'assets//3M136/DL001.apk'
        break
      // case '0567661988':
      //   linkMB = 'assets/files/Holika_0567661988_1806.apk'
      //   // link3M = 'assets//3M136/DL001.apk'
      //   break
      case '3m002': //3M002
        // linkMB = 'assets/files/1780/Holika_0567661988_1782.apk'
        link3M = 'assets/3M136/DL002_160.apk'
        break
      // case '3m006': //3M006
      //   // linkMB = 'assets/files/1780/Holika_0567661988_1782.apk'
      //   link3M = 'assets/3M136/DL006_160.apk'
      //   break
      default:
        break
    }

    return (
      <div className="App">
        {/* NAVBAR */}
        <nav
          id="navbar"
          className="navbar fixed-top navbar-expand-lg navbar-header navbar-mobile"
        >
          <div className="navbar-container container">
            {/* LOGO */}
            <div className="navbar-brand">
              <a className="navbar-brand-logo" href="#top">
                <img
                  src="assets/images/phanmemtinhbang.com.png"
                  alt="phanmemtinhbang.com"
                  width="120"
                  height="40"
                />
              </a>
            </div>

            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNav"
            ></div>
          </div>
        </nav>
        {/* SECTION LABEL */}
        <div id="top"></div>
        {/* WRAPPER */}
        <main className="wrapper">
          <div className="header">
            <div className="container header-container padding0px">
              <div className="col-lg-6 header-img-section padding0px">
                <LazyVideo
                  src="assets/images/mienbac.mp4"
                  poster="assets/images/mienbac-poster.jpg"
                  ariaLabel="XOSOPRO Phần mềm tính bảng Miền Bắc"
                  priority
                />
              </div>
              <div className="col-lg-6 header-title-section">
                <h1 className="header-title">
                  XOSOPRO Phần mềm tính bảng Miền Bắc
                </h1>
                <p className="header-title-text">
                  Dành cho cách chơi theo kiểu miền bắc
                </p>
                <div className="learn-more-btn-section">
                  {/* <a className="nav-link learn-more-btn" href="http://www.xosopro.us">Video Hướng Dẫn</a> */}
                  <Link to={videoMB} className="nav-link learn-more-btn">
                    Video Hướng Dẫn
                  </Link>
                  <a
                    className="nav-link learn-extra-btn"
                    target="_self"
                    download
                    href={linkMB}
                  >
                    <IconAndroid /> Tải
                    phần mềm MB
                  </a>
                </div>
                <div className="learn-more-btn-section">
                  <a
                    className="nav-link learn-extra-btn"
                    target="_self"
                    download
                    href="assets/files/ZALO-21-01-01-1.apk"
                  >
                    <IconAndroid /> Tải
                    Zalo bản cũ
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="header" style={{ padding: '10px 0 100px 0' }}>
            <div className="container header-container padding0px">
              <div className="col-lg-6 header-img-section padding0px">
                <LazyVideo
                  src="assets/images/bamien.mp4"
                  poster="assets/images/bamien-poster.jpg"
                  ariaLabel="KẾ TOÁN 3M Phần mềm tính bảng 3 Miền"
                />
              </div>
              <div className="col-lg-6 header-title-section">
                <h1 className="header-title">
                  KẾ TOÁN 3M Phần mềm tính bảng 3 Miền
                </h1>
                <p className="header-title-text">
                  Dành cho cách chơi theo kiểu miền Nam
                </p>
                <div className="learn-more-btn-section">
                  <Link to={video3M} className="nav-link learn-more-btn">
                    Video Hướng Dẫn
                  </Link>

                  {/* <a className="nav-link learn-more-btn" href="http://www.xosopro.us">Video Hướng Dẫn</a> */}
                  <a
                    className="nav-link learn-extra-btn"
                    target="_self"
                    download
                    href={link3M}
                  >
                    <IconAndroid /> Tải
                    phần mềm 3M
                  </a>
                </div>
                <div className="learn-more-btn-section">
                  <a
                    className="nav-link learn-extra-btn"
                    target="_self"
                    download
                    href="assets/files/ZALO-21-01-01-1.apk"
                  >
                    <IconAndroid /> Tải
                    Zalo bản cũ
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* TUTORS */}
          <div className="tutors-section">
            <div className="container tutors-container">
              <div className="pricing-title">
                <h2>Liên hệ</h2>
                <p>
                  {' '}
                  Phần mềm được cung cấp dùng thử miễn phí dài hạn. Vui lòng
                  liên hệ để được hướng dẫn sử dụng.
                </p>
              </div>
              <div className="container tutors-img-container">
                <div className="col-lg-2 col-md-6 col-sm-6 col-6 tutors-card-section">
                  <div className="tutors-card">
                    <div className="tutors-card-icon-section">
                      {/* <img src="assets/images/tutor1.svg" /> */}
                      <IconTelegram style={{ fontSize: '70px' }} />
                    </div>
                    <h2>
                      {/* <a href="tel:0981715186">0981.715.186</a> */}
                      <a
                        href="https://t.me/phanmemxoso"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        Telegram 24/7
                      </a>
                    </h2>
                    
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 col-6 tutors-card-section">
                  <div className="tutors-card">
                    <div className="tutors-card-icon-section">
                      <IconFacebook style={{ fontSize: '70px' }} />
                    </div>
                    <h2>
                      <a href="https://www.facebook.com/100011505182631">
                        Hà Đức Tuấn
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="header" style={{ paddingTop: '20px' }}></div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}

export default Home
